import { memo, useCallback } from "react";
import { WidePopup } from "components/popups/WidePopup";
import { ManageGifForm } from "components/manage/ManageGifForm";
import { IEditGifPopupProps } from "@/common/buses/popups/popup-types";
import { onCloseEditGifPopup } from "@/components/popup-dispatcher/PopupDispatcher";
import "./EditGifPopup.scss";

export const EditGifPopup: React.FC<IEditGifPopupProps> = memo(({
  gif,
  scrollToSection,
  getUserGifs
}) => {
  const onClose = useCallback(() => {
    onCloseEditGifPopup();
  }, []);

  return (
    <WidePopup
      isOpen={true}
      onClose={onClose}
      popupClass="EditGifPopup"
      title="Edit"
    >
      <ManageGifForm gif={gif} onClosePopup={onClose} scrollToSection={scrollToSection} getUserGifs={getUserGifs} />
    </WidePopup>
  );
});
